
const agendaGridConfig = {
  idField: "idAgendamento",
  columns: [
    
    { header: "Data", field: "data" },
    { header: "Horário", field: "horario", 
      formatter: (value) => value !== null && value !== undefined
        ? `${(value).slice(0,5)} h` : "-"
    },
    { header: "Especialidade", field: "descricao" },
    { header: "Cliente", field: "nome" }
  ]
};

export default agendaGridConfig;